/* tslint:disable */
import { OnInit, Component } from "@angular/core";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../../../../../../shared/services/auth.service";
import { FormGroup, FormBuilder, FormArray, FormControl, ValidatorFn, Validators } from "@angular/forms";
import { DatoPaginadoModel, Paging } from "src/app/shared/models/dato-paginado.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { EstablecimientoComercioService } from "../../../prestador/establecimiento-comercio/establecimiento-comercio.service";
import { HttpEventType } from "@angular/common/http";
import { ReporteEncuestaService } from './reporte-encuesta.service';
import * as FileSaver from "file-saver";
import { EstadoSolicitudEntry } from "src/app/shared/entrys/estado-solicitud.entry";

@Component({
  selector: "app-reporte-encuesta",
  templateUrl: "./reporte-encuesta.component.html",
  styleUrls: ["./reporte-encuesta.component.scss"]
})
export class ReporteEncuestaComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  formUsuario: FormGroup;
  selectUsuario: any;
  camarasLista: Array<CamaraComercioEntry>;
  paginaActual: number;
  adminSuper = RolesUsuario.AdministradorSuper;
  prestador = RolesUsuario.Prestador;
  adminCC = RolesUsuario.AdministradorCC;
  columnas: Array<any> = [];
  columnasEnvio: any;
  // filtros
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = false;
  isExportar = true;
  camaraComercio: string;
  // Selects
  categoria: Array<any> = [];
  sub_categoria: Array<any> = [];
  tipos_rnt: Array<any> = [];
  exportarForm: FormGroup;
  header: any;
  estado_solicitud: Array<EstadoSolicitudEntry> = [];
  listaFuncionarios: Array<any>;
  private listaPreguntas: Array<any>;

  constructor(
    private formBuilder: FormBuilder,
    private establecimientoComercioService: EstablecimientoComercioService,
    public authService: AuthService,
    private reporteEncuestaService: ReporteEncuestaService
  ) {
    this.createPagingTable();
    this.createForm();

    this.selectUsuario = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.consultarLista();
  }

  createForm() {
    this.filtro = this.formBuilder.group({
      codigo_camara: [!this.authService.getRolUser(this.adminCC) ? null : this.authService.getCamaraUser(), Validators.required],
      anio: [null, Validators.required],
      categoria_id: [null, Validators.required],
      sub_categoria_id: [null, Validators.required],
      nit: [null],
      matricula: [null],
      razon_social: [null],
      tipo_rnt_id: [null],
      numero_radicado: [null],
      funcionario_id: [null],
      estado_solicitud_id: [null],
      codigo_rnt: [null]
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging
    } as DatoPaginadoModel;
  }

  onConsultarReporteEncuesta(page: number) {
    this.reporteEncuestaService.getEncabezadoDataTable({
      ...this.filtro.value, numeroPagina: page
    })
      .subscribe(resultado => {
        if (resultado.result) {
          this.header = resultado.data[0];
          this.calcularEncabezadoTabla();
          this.reporteEncuestaService.getDataTable({
            ...this.filtro.value, numeroPagina: page
          })
            .subscribe(resultado => {
              if (resultado.result) {
                this.dataTabla = resultado.data;
                this.ordenarDataTabla();
              }
            });
        }
      });

  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarReporteEncuesta(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarReporteEncuesta(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtro.get('codigo_camara').setValue(!this.authService.getRolUser(this.adminCC) ? null : this.authService.getCamaraUser());
    this.onSubcategoriaSelect();
    this.createPagingTable();
    this.dataTabla.items = [];
    this.header = null;
    if (!this.authService.getRolUser(this.adminCC)) {
      this.listaFuncionarios = null;
      this.filtro.get('funcionario_id').setValue(null);
    }
  }

  onSubcategoriaSelect() {
    // tslint:disable-next-line:triple-equals
    if (this.filtro.value.categoria_id == null) {
      this.sub_categoria = null;
      this.filtro.get('sub_categoria_id').setValue(null);
    } else {
      this.reporteEncuestaService.getSubCategoriaxCategoria(this.filtro.value.categoria_id)
        .subscribe(resultado => {
          if (resultado.result) {
            this.sub_categoria = resultado.data;
          } else {
            this.sub_categoria = null;
            this.filtro.get('sub_categoria_id').setValue(null);
          }
        });
    }
  }

  submit() {
    this.reporteEncuestaService.generarExportarInformeEncuesta({ ...this.filtro.value })
      .subscribe(resultado => {
        if (resultado.type === HttpEventType.Response) {
          if (resultado.ok) {
            this.saveAsExcelFile(resultado.body, `reporte_encuesta.xlsx`);
          }
        }
      });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }

  ordenarDataTabla() {
    if (this.dataTabla.items && this.dataTabla.items.length > 0) {
      this.dataTabla.items.map((data) => {
        const newRespuestas = [];
        let respuesta = null;
        let cambio = true;
        for (let preIndex = 0; preIndex < this.listaPreguntas.length; preIndex++) {
          for (let index = 0; index < data.respuestas.length; index++) {
            //respuesta = data.respuestas[index];
            respuesta = Object.create(data.respuestas[index]);
            if (this.listaPreguntas[preIndex] == respuesta.pregunta_encuesta_id) {
              cambio = false;
              break;
            } else {
              cambio = true;
            }
          }
          if (cambio)
            respuesta.respuesta = null;
          newRespuestas.push(respuesta);
        }

        data.respuestas = newRespuestas;
        return data;
      });
    }
    // this.dataTabla.items = [];
  }

  calcularEncabezadoTabla() {
    let fila = 1;
    let column = 1;
    let maxFila = fila;
    this.listaPreguntas = new Array<any>();
    if (this.header.modulos != null && this.header.modulos.length > 0) {
      for (let modulo of this.header.modulos) {
        modulo.columnSpan = 0;
        column++;
        if (modulo.secciones != null && modulo.secciones.length > 0) {
          //modulo.columnSpan = modulo.secciones.length === 1 ? 0 : modulo.secciones.length;
          fila++;
          if (maxFila < fila)
            maxFila = fila;
          for (let seccion = 0; seccion < modulo.secciones.length; seccion++) {
            modulo.secciones[seccion].columnSpan = 0;
            if (modulo.secciones[seccion].preguntas != null && modulo.secciones[seccion].preguntas.length > 0) {
              modulo.secciones[seccion].columnSpan = modulo.secciones[seccion].preguntas.length > 0 ? modulo.secciones[seccion].preguntas.length : 1;
              fila++;
              if (maxFila < fila)
                maxFila = fila;
              for (let pregunta = 0; pregunta < modulo.secciones[seccion].preguntas.length; pregunta++) {
                // modulo.secciones[seccion].preguntas[pregunta].columnSpan = (modulo.secciones[seccion].preguntas[pregunta].opciones && modulo.secciones[seccion].preguntas[pregunta].opciones.length > 0) ? modulo.secciones[seccion].preguntas[pregunta].opciones.length : 1;
                // modulo.secciones[seccion].columnSpan += modulo.secciones[seccion].preguntas[pregunta].columnSpan > 0 ? modulo.secciones[seccion].preguntas[pregunta].columnSpan : 1;
                this.listaPreguntas.push(modulo.secciones[seccion].preguntas[pregunta].pregunta_encuesta_id);
                if ((pregunta + 1) < modulo.secciones[seccion].preguntas.length) {
                  column++;
                }
              }
              fila--;
            }
            modulo.columnSpan += modulo.secciones[seccion].columnSpan;
            if ((seccion + 1) < modulo.secciones.length) {
              column++;
            }
          }
          fila--;
        }
      }
    }
    this.header.maxFila = maxFila;
    this.header.maxColumn = column;
  }

  getEntries(value: any) {
    return Object.keys(value).map((key) => value[key]);
  }

  onOpenCalendar(container) {
    container.yearSelectHandler = (event: any): void => {
      this.filtro.get('anio').setValue((event.date as Date).getFullYear().toString());
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('year');
  }

  cargarListaFuncionario() {
    if (this.filtro.value.codigo_camara == null) {
      this.listaFuncionarios = null;
      this.filtro.get('funcionario_id').setValue(null);
    } else {
      this.reporteEncuestaService.getFuncionarios({ codigo_camara: this.filtro.value.codigo_camara, es_destino: false })
        .subscribe(resultado => {
          if (resultado.result) {
            this.listaFuncionarios = resultado.data;
          }
        });
    }
  }

  consultarLista() {
    this.reporteEncuestaService.getCategoria().subscribe(resultado => {
      if (resultado.result) {
        this.categoria = resultado.data;
      }
    });

    this.reporteEncuestaService.getTipoRnt().subscribe(resultado => {
      if (resultado.result) {
        this.tipos_rnt = resultado.data;
      }
    });
    // this.reporteEncuestaService.getTipoSolicitud().subscribe(resultado => {
    //   if (resultado.result) {
    //     this.tipo_solicitud = resultado.data;
    //   }
    // });
    this.reporteEncuestaService.getEstadoSolicitud().subscribe(resultado => {
      if (resultado.result) {
        this.estado_solicitud = resultado.data;
      }
    });

    if (!this.authService.getRolUser(this.adminCC)) {
      this.reporteEncuestaService.getCamaras().subscribe(resultado => {
        if (resultado) {
          this.camarasLista = resultado.data as Array<CamaraComercioEntry>;
        }
      });
    } else {
      this.cargarListaFuncionario();
    }
  }
}
